<div class="modal-content">
  <div class="modal-header" id="social-share-btns-modal-header">
        <h5 class="modal-title" title="select-exam">
          <p [innerHtml]="title"></p>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body">
      <div class="modal-info" id="social-share-btns-body">
        <div class="row p-3">
          <p [innerHtml]="description"></p>
        </div>
        <div class="row p-3" *ngIf="imgSrc">
          <img src="{{imgSrc}}" style="width: 100%; height: auto; padding: 5px;">
        </div>
      <div class="row mt-3">
          <div class="col-12 text-right">
              <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-target="#select-subject-post" (click)="closeModal()" data-toggle="modal">Close</button>
          </div>
      </div>

      </div>
      <!-- BODY Of POPUP ENDS -->
  </div>
</div>
